export const firebaseConfig = {
    apiKey: "AIzaSyDSe9dEiEjQVoB_voLaet4zMsQ74nZm03s",
    authDomain: "active-waiting.firebaseapp.com",
    projectId: "active-waiting",
    storageBucket: "active-waiting.appspot.com",
    messagingSenderId: "258698208122",
    appId: "1:258698208122:web:a2d4070a17a9a5c5796cc3",
};
